import { assetApi } from './assetApiBase';
import { AssetDocumentView } from './types/assetTypes';

// `upsertAsset` comes from @trackly/shared's createAssetApi, which reads the ETag and merge
// headers. A second definition injected here was silently ignored by RTK Query, so it is gone;
// the hook below is still generated for the shared endpoint.
export const assetMutationsApi = assetApi.injectEndpoints({
  endpoints: (builder) => ({
    // Upload a document to an asset (FormData with file + documentType)
    uploadAssetDocument: builder.mutation<AssetDocumentView, { assetId: string; file: File; documentType: string }>({
      query: ({ assetId, file, documentType }) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('documentType', documentType);
        return {
          url: `assets/${assetId}/documents`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { assetId }) => [
        { type: 'Document', id: assetId },
        'Document',
      ],
    }),

    // Download a document
    downloadAssetDocument: builder.mutation<Blob, { assetId: string; documentId: string }>({
      query: ({ assetId, documentId }) => ({
        url: `assets/${assetId}/documents/${documentId}/download`,
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),

    // Delete a document
    deleteAssetDocument: builder.mutation<void, { assetId: string; documentId: string }>({
      query: ({ assetId, documentId }) => ({
        url: `assets/${assetId}/documents/${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { assetId }) => [
        { type: 'Document', id: assetId },
        'Document',
      ],
    }),
  }),
});

export const {
  useUpsertAssetMutation,
  useUploadAssetDocumentMutation,
  useDownloadAssetDocumentMutation,
  useDeleteAssetDocumentMutation,
} = assetMutationsApi;
